import { Col, Row } from '@flos/react-ui';

import React from 'react';
import styles from './OpeningHours.module.scss';
import { useResourceBundle } from '../contexts/ResourceContext';

export interface DepartmentsAndOpeningHours {
    label: string;
    openTime: number | null;
    closeTime: number | null;
    openText: string;
    closeText: string;
    isOpen: boolean;
}
const OpeningHours = ({
    labelHeader,
    labelHeaderSuffix,
    departments,
}: {
    departments: DepartmentsAndOpeningHours[];
    labelHeader: string;
    labelHeaderSuffix: string;
}) => {
    const resource = useResourceBundle();

    return (
        <div className={`Box Box--spot`}>
            <header className={styles['opening-reminder']}>
                <h3>{`${resource[labelHeader]} ${labelHeaderSuffix}`}</h3>
            </header>
            <article className={styles.dept}>
                {departments.map(({ label, openText, closeText, isOpen }) => {
                    const openOrClosedText = isOpen ? '' : resource['label.closed'];

                    return (
                        <div key={'openingHours-' + label}>
                            <Row>
                                <Col xs={12}>
                                    <b>{resource[label]}:</b>{' '}
                                    <span className={styles.departmentclosed}>{openOrClosedText}</span>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={12}>{openText + ' - ' + closeText}</Col>
                            </Row>
                            <br />
                        </div>
                    );
                })}
            </article>
        </div>
    );
};

export default OpeningHours;
